import React from "react";

export default function UserDetailsComponent({ userInfo }) {

  // ✅ Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      month: "short",   // Jan
      year: "numeric"   // 2026
    });
  };

  return (
    <div className="user-card">
      <div className="user-card__top">
        <div className="avatar">
          <span>👤</span>
        </div>

        <div className="user-info">
          <h3>{userInfo?.username}</h3>
          <p>{userInfo?.email}</p>
        </div>
      </div>

      <hr />

      <div className="user-card__bottom">
        <div className="info-row">
          <span className="label">Phone</span>
          <span className="value">{userInfo?.mobile_number}</span>
        </div>

        <div className="info-row">
          <span className="label">Member Since</span>
          <span className="value">
            {formatDate(userInfo?.date_joined)}
          </span>
        </div>
      </div>
    </div>
  );
}